import { clone, onError } from '../../../../common/common';
import { MoodboardApi } from '../../../api/moodboard-api';

// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_HEADER_STATUS = 'UPDATE_HEADER_STATUS';

// ------------------------------------
// Actions
// ------------------------------------

export const updateHeaderStatus = (dispatch, status) => {
  dispatch({ type: UPDATE_HEADER_STATUS, payload: { status } });
};

export const checkHeaderStatus = () => {
  return (dispatch, getState) => {
    return new Promise(resolve => {
      MoodboardApi.checkStatus(data => {
        updateHeaderStatus(dispatch, data);
      }, onError);
      resolve();
    });
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const processUpdate = (state, action) => {
  let newState = clone(state);
  newState.headerStatus = { ...newState.headerStatus, ...action.payload.status };
  return newState;
};

export const HEADER_ACTION_HANDLERS = {
  [UPDATE_HEADER_STATUS]: processUpdate,
};



// WEBPACK FOOTER //
// ./app/javascript/design/routes/common/modules/header.js